/**
 * Public storefront content must render the same result for every visitor.
 * Keep its SSR request bounded and never make an authenticated upstream call
 * while Nuxt is producing a shareable HTML payload.
 */
export const PUBLIC_CONTENT_SSR_TIMEOUT_MS = 4_000

/**
 * @param {Record<string, unknown>} [options]
 * @returns {Record<string, unknown>}
 */
export function createPublicContentSsrRequestConfig(options = {}) {
  return {
    showError: false,
    ssrAuth: false,
    timeout: PUBLIC_CONTENT_SSR_TIMEOUT_MS,
    ...options,
  }
}

/**
 * @param {Record<string, unknown> | undefined} config
 * @returns {boolean}
 */
export function shouldForwardSsrAuth(config) {
  return config?.ssrAuth !== false
}
